import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import { toast, failed } from '../lib/toast'

// "My Account" — available to EVERY logged-in user (office, QM, Admin, and Auditor). Lets a user change
// their own password (Supabase Auth, independent of RLS) and set their own quotation initials (via the
// set_my_initials RPC, since direct user_profiles writes are Admin-only).
const sectionStyle = { border: '1px solid var(--border, #e2e2e2)', borderRadius: 8, padding: 18, marginBottom: 18, background: 'var(--card, #fff)' }

export default function Account() {
  const { user, profile, role } = useAuth()
  const [pw1, setPw1] = useState(''); const [pw2, setPw2] = useState(''); const [pwBusy, setPwBusy] = useState(false)
  const [initials, setInitials] = useState(''); const [initBusy, setInitBusy] = useState(false)

  useEffect(() => { if (profile?.initials) setInitials(profile.initials) }, [profile?.initials])

  async function changePassword() {
    if ((pw1 || '').length < 8) { toast('Password too short', 'warning', { detail: 'Use at least 8 characters' }); return }
    if (pw1 !== pw2) { toast("Passwords don't match", 'warning'); return }
    setPwBusy(true)
    const { error } = await supabase.auth.updateUser({ password: pw1 })
    setPwBusy(false)
    if (error) { failed("Couldn't change your password", error.message); return }
    setPw1(''); setPw2(''); toast('Password updated', 'success')
  }

  async function saveInitials() {
    setInitBusy(true)
    const { error } = await supabase.rpc('set_my_initials', { p_initials: (initials || '').toUpperCase() })
    setInitBusy(false)
    if (error) { failed("Couldn't save your initials", error.message); return }
    localStorage.setItem('user_initials', (initials || '').toUpperCase())
    toast('Initials saved', 'success')
  }

  return (
    <div style={{ maxWidth: 560 }}>
      <h1 style={{ marginBottom: 4 }}>My Account</h1>
      <div style={{ color: 'var(--text2)', marginBottom: 20 }}>{profile?.name} · {role} · {user?.email}</div>

      <section style={sectionStyle}>
        <h3 style={{ marginTop: 0 }}>Change password</h3>
        <div className="field"><label>New password</label>
          <input type="password" value={pw1} onChange={e => setPw1(e.target.value)} placeholder="At least 8 characters" /></div>
        <div className="field"><label>Confirm new password</label>
          <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} /></div>
        <button className="primary" disabled={pwBusy} onClick={changePassword}>{pwBusy ? 'Saving…' : 'Update password'}</button>
      </section>

      <section style={sectionStyle}>
        <h3 style={{ marginTop: 0 }}>My quotation initials</h3>
        <div style={{ color: 'var(--text3)', fontSize: 13, marginBottom: 10 }}>
          Used in the quotation reference you generate (e.g. <code>pm/1501-26/{(initials || 'XX').toUpperCase()}</code>).
        </div>
        <div className="field"><label>Initials</label>
          <input value={initials} onChange={e => setInitials(e.target.value.toUpperCase())} maxLength={5} style={{ maxWidth: 140 }} /></div>
        <button className="primary" disabled={initBusy} onClick={saveInitials}>{initBusy ? 'Saving…' : 'Save initials'}</button>
      </section>
    </div>
  )
}
